import MainRoute from "./routes/MainRoute";

const App = () => {
  return <MainRoute />;
};

export default App;
